import React from "react";
import PageTitle from "../../components/shared/PageTitle";
import { useSelector } from "react-redux";

export default function RaceResult() {
  const locale = useSelector((state) => state.locale.locale);
  return (
    <div className="min-h-svh text-white px-4">
      <div className="relative">
        <PageTitle title={locale === "en" ? "Race Result" : "Hasil Lomba"} />
      </div>
      <div className="top-80 relative bg-black">
        <div className="bg-black container mx-auto w-full font-ttFirsNeue text-black">
          <div className="block items-center flex-row gap-x-10 md:flex">
            <a
              className="block py-2 bg-white px-8 text-lg text-center rounded-md w-full font-bold mb-10"
              href="https://racetecresults.com/results.aspx?CId=19723&RId=156"
              target="_blank"
              rel="noreferrer"
            >
              2023
            </a>
            <a
              className="block py-2 bg-white px-8 text-lg text-center rounded-md w-full font-bold mb-10"
              href="https://racetecresults.com/results.aspx?CId=20127&RId=6005"
              target="_blank"
              rel="noreferrer"
            >
              2024
            </a>
            <a
              className="block py-2 bg-white px-8 text-lg text-center rounded-md w-full font-bold mb-10"
              href="https://racetecresults.com/results.aspx?CId=20127&RId=6049"
              target="_blank"
              rel="noreferrer"
            >
              2025
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

/* <div className="mt-20 2xl:px-0 md:px-14 px-0">
    {currentIndex === 0 ? (
        <iframe
            title="Lokasi"
            src="https://racetecresults.com/results.aspx?CId=19723&RId=156"
            allowfullscreen="true"
            loading="lazy"
            referrerpolicy="no-referrer-when-downgrade"
            className="w-full h-[90rem] rounded-lg"
        ></iframe>
    ) : (currentIndex === 1 ?
        (<iframe
            title="Lokasi"
            src="https://racetecresults.com/results.aspx?CId=20127&RId=6005"
            allowfullscreen="true"
            loading="lazy"
            referrerpolicy="no-referrer-when-downgrade"
            className="w-full h-[90rem] rounded-lg"
        ></iframe>)
        : <iframe
            title="Lokasi"
            src="https://racetecresults.com/results.aspx?CId=20127&RId=6049&EId=1"
            allowfullscreen="true"
            loading="lazy"
            referrerpolicy="no-referrer-when-downgrade"
            className="w-full h-[90rem] rounded-lg"
        ></iframe>)}
</div> */
